import type { McqQuestion } from '../../fetchSurvey/types/mcq';
import type { SurveyAnswers } from '../../submitSurvey/types';
import {
  buildMcqOptionLevelKey,
  isMcqOtherOptionSelected,
} from './mcqOtherUtils';
import { isMcqOtherTextValid } from './validateMcqOtherText';

export function validateMcqOtherAnswers(
  question: McqQuestion,
  answers: SurveyAnswers,
  defaultRequiredMessage: string
): string | undefined {
  const selection = answers[question.id];
  const selectedIds =
    question.selectionMode === 'multiple'
      ? Array.isArray(selection)
        ? selection.filter((id): id is string => typeof id === 'string')
        : []
      : typeof selection === 'string'
        ? [selection]
        : [];

  for (const option of question.options) {
    if (!option.otherOption) {
      continue;
    }

    if (!isMcqOtherOptionSelected(question, selection, option.id)) {
      continue;
    }

    const otherTextKey = buildMcqOptionLevelKey(question.id, option.id);
    const rawOtherText = answers[otherTextKey];
    const otherText = typeof rawOtherText === 'string' ? rawOtherText.trim() : '';
    const config = option.otherOption;

    if (!otherText) {
      if (config.markRequired) {
        return question.requiredErrorMessage ?? defaultRequiredMessage;
      }
      continue;
    }

    if (!isMcqOtherTextValid(config, otherText)) {
      return config.errorMessage ?? question.requiredErrorMessage ?? defaultRequiredMessage;
    }
  }

  if (selectedIds.length === 0) {
    return undefined;
  }

  return undefined;
}
